export default {
  care: {
    hero: {
      eyebrow: 'SSG Care',
      title: 'So your camera technology works reliably in the long term',
      lead: 'SSG Care is our maintenance and support subscription. After installation you can have your system continuously supported under a flexible Care contract – for a monthly fee and with an individually agreed term.',
    },
    abo: {
      title: 'Subscription model with a flexible term',
      lead: 'Installation is billed once. Ongoing support runs via a monthly subscription – cancellable or with a fixed agreed minimum term.',
      items: {
        '0': { title: 'Monthly support', desc: 'Choose between monthly cancellation or a fixed term (e.g. 12 or 24 months) with corresponding conditions.' },
        '1': { title: 'Individual scope of services', desc: 'Not every system needs everything. Together we define which services belong in your Care contract – scalable and adaptable.' },
        '2': { title: 'No hidden costs', desc: 'Transparent monthly fee. Additional services outside the contract are agreed in advance and billed separately.' },
      },
    },
    pricing: {
      eyebrow: 'Plans',
      title: 'Choose your Care plan',
      lead: 'All prices are guide values. The final monthly fee depends on the size of your system, the desired scope and the term.',
      featured: 'Most popular',
      plans: {
        '0': { name: 'Care Basic', subtitle: 'For small systems', price: 'from €19/month', features: { '0': 'Quarterly system check (remote)', '1': 'Firmware update management', '2': 'App support by phone/email', '3': 'Prioritised support requests' } },
        '1': { name: 'Care Professional', subtitle: 'For commercial systems', price: 'from €39/month', features: { '0': 'Monthly system check (remote)', '1': 'Firmware updates & security patches', '2': 'User and rights management', '3': 'Storage & recording check', '4': 'Help with smartphone change', '5': 'On-site service by arrangement', '6': 'Prioritised handling' } },
        '2': { name: 'Care Enterprise', subtitle: 'For multi-site & large projects', price: 'Individual', features: { '0': 'Weekly system check (remote)', '1': 'All Professional services', '2': 'Dedicated contact person', '3': 'Proactive expansion advice', '4': 'Regular on-site appointments', '5': 'Documentation & reporting' } },
      },
    },
    services: {
      title: 'What SSG Care can do for you',
      items: {
        '0': { title: 'Regular system checks', desc: 'Checking camera function, recording and network connection – remotely or on site depending on the plan.' },
        '1': { title: 'Firmware updates', desc: 'Checking and performing agreed firmware updates per manufacturer specifications for security and stability.' },
        '2': { title: 'App and access support', desc: 'Support with app issues, access questions and help with smartphone changes or reinstallation.' },
        '3': { title: 'User and rights management', desc: 'Managing access rights, new users and permission changes for employees and family.' },
        '4': { title: 'Recording and storage', desc: 'Checking storage usage, recording quality and backup status of your recorder.' },
        '5': { title: 'Remote support', desc: 'Remote access for diagnostics and configuration, where technically possible and desired by you.' },
      },
    },
    form: {
      title: 'Your personal Care offer',
      lead: 'Tell us what support you have in mind. We will get back to you with an individual proposal including term and monthly fee.',
      customerType: 'Customer type',
      select: 'Please select',
      privat: 'Private',
      gewerbe: 'Commercial',
      locations: 'Number of locations',
      locations1: '1 location',
      locations2: '2–3 locations',
      locations3: '4 and more',
      cameraCount: 'Approximate number of cameras',
      cameras1: '1–2 cameras',
      cameras2: '3–6 cameras',
      cameras3: '7–12 cameras',
      cameras4: '13 and more',
      systemStatus: 'System status',
      statusNew: 'New system',
      statusExisting: 'Existing system',
      statusExtension: 'Extension planned',
      contractTerm: 'Desired contract term',
      termOpen: 'Open / by arrangement',
      termMonthly: 'Monthly cancellation',
      term12: '12 months',
      term24: '24 months',
      term36: '36 months',
      name: 'Name *',
      email: 'Email *',
      phone: 'Phone',
      company: 'Company',
      message: 'Additional information',
      maxChars: 'Maximum 500 characters',
      consent: 'I have read the privacy policy and agree to the processing of my data to handle this request. *',
      success: 'Thank you for your request. We will get back to you shortly with your individual Care offer.',
      submit: 'Send Care request',
      submitting: 'Sending...',
    },
  },
};